<template>
  <div id="todo-app">
    <div class="vs-row">
      <vs-col class="p-0" vs-xs="12" vs-sm="4" vs-lg="2" id="sidebar-div">
        <div class="con-vs-card cardx h-full mb-0">
          <header class="vs-card--header flex">
            <h5 class="font-medium">Tasks</h5>
            <vs-button color="primary" class="whitespace-no-wrap ml-auto"
              ><i class="icon-plus align-middle text-white"></i> Add
              New</vs-button
            >
          </header>
          <div class="vs-card--content p-0">
            <ul class="nav flex-column todo-menu">
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#"
                  :class="[{ active: todolist == '' }]"
                  @click="activetodo('')"
                  data-todotype="todo-item"
                >
                  <i class="icon-list"></i> All
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#"
                  :class="[{ active: todolist == 'starred' }]"
                  @click="activetodo('starred')"
                  data-todotype="starred"
                >
                  <i class="icon-star"></i> Starred
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#"
                  :class="[{ active: todolist == 'important' }]"
                  @click="activetodo('important')"
                  data-todotype="important"
                >
                  <i class="icon-exclamation"></i> Important
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#"
                  :class="[{ active: todolist == 'completed' }]"
                  @click="activetodo('completed')"
                  data-todotype="completed"
                >
                  <i class="icon-check"></i> Completed
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#"
                  :class="[{ active: todolist == 'deleted' }]"
                  @click="activetodo('deleted')"
                  data-todotype="trashed"
                >
                  <i class="icon-trash"></i> Trashed
                </a>
              </li>
            </ul>
          </div>
        </div>
      </vs-col>
      <vs-col class="p-0" vs-sm="8" vs-xs="12" vs-lg="10">
        <div class="con-vs-card cardx mb-0 h-full rounded-none border-l-0">
          <div class="vs-card--content h-full p-0">
            <div class="todo-window p-0">
              <div class="flex items-center todo-search">
                <vs-input
                  size="large"
                  placeholder="Search..."
                  class="border-0 w-full"
                />
              </div>
              <VuePerfectScrollbar
                ref="chatwindow"
                class="scroll-area-todo-window"
                :settings="settings"
                @ps-scroll-y="scrollHandle"
              >
                <ul id="component-todo-log" v-if="todos" ref="chatLog">
                  <li
                    v-for="(todo, index) in filterlist"
                    class="todo-item flex"
                    :class="[
                      { completed: todo.completed },
                      { starred: todo.starred },
                      { important: todo.important },
                      { deleted: todo.deleted },
                    ]"
                    :key="index"
                  >
                    <vs-checkbox
                      v-model="todo.completed"
                      class="w-8 m-0 vs-checkbox-medium"
                      @click.stop
                    />
                    <div class="todo-content">
                      <h3>
                        {{ todo.subject }}
                      </h3>
                      <p class="text-muted mb-0 font-bold text-opacity-5">
                        June 8, 2020
                      </p>
                      <p class="small-content text-muted mb-0">
                        {{ todo.content.substring(0, 110) + "..." }}
                      </p>
                    </div>
                    <div class="ml-auto">
                      <i class="icon-star mr-2 font-15"></i>
                      <i class="icon-exclamation font-15 mr-2"></i>
                    </div>
                    <div>
                      <vs-dropdown>
                        <a class="a-icon" href="#">
                          <i class="icon-options-vertical font-15"></i>
                        </a>

                        <vs-dropdown-menu>
                          <vs-dropdown-item> Edit </vs-dropdown-item>
                          <vs-dropdown-item> Delete </vs-dropdown-item>
                        </vs-dropdown-menu>
                      </vs-dropdown>
                    </div>
                  </li>
                </ul>
              </VuePerfectScrollbar>
            </div>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
  name: "app",
  components: {
    VuePerfectScrollbar,
  },
  data: function () {
    return {
      settings: {
        maxScrollbarLength: 60,
      },
      todolist: "",
      filterlist:[],
      todos: [
        {
          subject: "Aenean ligula porttitor consequat vitae eleifend enim.",
          content:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          time: "June 8, 2020",
          starred: true,
          important: false,
          completed: false,
          deleted: false,
        },
        {
          subject:
            "In enim justo, rhoncus ut imperdiet a, venenatis vitae justo.",
          content:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          time: "May 22, 2020",
          starred: false,
          important: true,
          completed: false,
          deleted: false,
        },
        {
          subject: "Cras dapibus vivamus elementum semper nisi.",
          content:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          time: "May 12, 2020",
          starred: false,
          important: false,
          completed: false,
          deleted: false,
        },
        {
          subject:
            "Donec quam felis ultricies nec, pellentesque eu pretium quis.",
          content:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          time: "April 30, 2020",
          starred: true,
          important: false,
          completed: true,
          deleted: false,
        },
        {
          subject:
            "Aenean leo ligula porttitor eu consequat vitae, eleifend ac enis.",
          content:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          time: "April 12, 2020",
          starred: true,
          important: true,
          completed: false,
          deleted: true,
        },
        {
          subject: "Curabitur ullamcorper ultricies nisi nam eget dui.",
          content:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          time: "March 18, 2020",
          starred: true,
          important: false,
          completed: true,
          deleted: true,
        },
      ],
    };
  },
  computed: {
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
  mounted(){
    this.filterlist=this.todos;
  },
  watch: {},
  created() {},
  methods: {
    scrollHandle(evt) {
      console.log(evt);
    },
    activetodo(type) {
      this.todolist = type;  
      if (type == "") {
        this.filterlist= this.todos;
      }   
      if (type == "starred") {
        this.filterlist= this.todos.filter(function (item) {
          return (item.starred);
        });
      }
      if (type == "important") {
        this.filterlist= this.todos.filter(function (item) {
          return (item.important);
        });
      }
      if (type == "completed") {
        this.filterlist= this.todos.filter(function (item) {
          return (item.completed);
        });
      }
      if (type == "deleted") {
        this.filterlist= this.todos.filter(function (item) {
          return (item.deleted);
        });
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/styles/apps/todo.scss";
</style>